import {BatchSchema} from 'constants/SampleConstants';
import {getColumnLabel} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {isTagValueStructuredTableColumn} from 'notebook/structured-tables/columns/TypePredicates';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {ParentStorableType} from 'samples/storables/StorableSchemaConstants';
import {Schema} from 'schemas/SchemaConstants';
import {StageRun} from 'workflows/WorkflowConstants';

import toColumnDefinition from './toColumnDefinition';

function preferColumnLabel(structuredTableColumn: StructuredTableColumn): boolean {
  if (structuredTableColumn.name == null || structuredTableColumn.name === '') {
    return true;
  }
  // Columns with units should use the column label to render the units in the output.
  return (
    structuredTableColumn.columnType === TableColumnType.QUANTITY ||
    structuredTableColumn.columnType === TableColumnType.CONCENTRATION
  );
}

export default function toColumnLabel({
  structuredTableColumn,
  stageRuns,
  schemas,
  parentStorableIsGrid,
  parentStorableType,
}: {
  structuredTableColumn: StructuredTableColumn;
  stageRuns?: Array<StageRun>;
  schemas: Array<Schema | BatchSchema>;
  parentStorableIsGrid?: boolean;
  parentStorableType?: ParentStorableType;
}): string | null {
  if (
    isTagValueStructuredTableColumn(structuredTableColumn) &&
    structuredTableColumn.schemaFieldDisplayName != null &&
    structuredTableColumn.schemaFieldDisplayName !== ''
  ) {
    return structuredTableColumn.schemaFieldDisplayName;
  } else if (preferColumnLabel(structuredTableColumn)) {
    // Quantity and Concentration columns must pass in canChangeUnits even though it doesn't affect the label
    const columnDefinition = toColumnDefinition({
      structuredTableColumn,
      stageRuns,
      canChangeUnits: false,
      schemas,
      parentStorableIsGrid,
      parentStorableType,
    });
    return getColumnLabel(columnDefinition);
  } else {
    return structuredTableColumn.name;
  }
}
